import { useMemo } from 'react';

import { getJobsPublicURL } from '~/config';
import { useRouter } from '~/hooks';

const transform = (path: string, businessUnit: string) => {
  const fullpath = `${getJobsPublicURL()}${path.startsWith(`/${businessUnit.toLowerCase()}`) ? path : `/${businessUnit.toLowerCase()}${path.length > 1 ? path : ''}`}`;
  return fullpath.match(/([^?]+)/)[0];
};

export const useCanonicalUrl = (): string => {
  const { asPath, businessUnit } = useRouter();

  return useMemo(() => transform(asPath, businessUnit), [asPath, businessUnit]);
};
